import React from 'react';
import HeaderBottomTwo from '../common/header/HeaderBottomTwo';
import HeaderTop from '../common/header/HeaderTop';
import HeroStyleThree from '../components/hero/HeroStyleThree';
import AboutBlock from '../components/about/AboutBlock';
import FunFact from '../components/fun-fact/FunFact';
import ServiceStyleThree from '../components/services/ServiceStyleThree';
import CtaThree from '../components/cta/CtaThree';
import WhyChoseUsTwo from '../components/why-choose-us/WhyChoseUsTwo';
import HowItWorkOne from '../components/how-it-work/HowItWorkOne';
import TestimonialStyleTwo from '../components/testimonial/TestimonialStyleTwo';
import ProjectStyleThree from '../components/project/ProjectStyleThree';
import CtaTwo from '../components/cta/CtaTwo';
import TeamStyleTwo from '../components/team/TeamStyleTwo';
import QueryFormStyleTwo from '../components/query-form/QueryFormStyleTwo';
import BlogStyleOne from '../components/blog/BlogStyleOne';
import Subscribe from '../components/subscribe/Subscribe';
import FooterTwo from '../common/footer/FooterTwo';

const HomeThree = () => {
    return (
        <>
            <HeaderTop />
            <HeaderBottomTwo />
            <HeroStyleThree />
            <AboutBlock />
            <FunFact />
            <ServiceStyleThree />
            <CtaThree />
            <WhyChoseUsTwo />
            <HowItWorkOne />
            <TestimonialStyleTwo />
            <ProjectStyleThree />
            <CtaTwo />
            <TeamStyleTwo />
            <QueryFormStyleTwo />
            <BlogStyleOne />
            <Subscribe />
            <FooterTwo />
        </>
    )
}

export default HomeThree;